module.exports = __webpack_public_path__ + "img/discount-available.30285eff.svg";